import {
    FETCH_DISCARD_BIN,
    RESET_DISCARD_BIN,
} from "../../constants/action.constants";

const initialState = {
    data: {},
    others: {
        total: 0,
        offset: 0,
        limit: 20,
    },
};

const discardedBinReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DISCARD_BIN:
            return { data: action.payload, others: action.others };
        case RESET_DISCARD_BIN:
            return initialState;
        default:
            return state;
}
};

export default discardedBinReducer;
  